import { ResumeDto } from "@reactive-resume/dto";

import useAjaxPdfDownload from "./use-ajax-pdf-download";
import useFileDownload from "./use-file-download";

const usePdfOutput = () => {
  const { loading, download } = useAjaxPdfDownload();

  const { download: fileSave, downloading: fileSaveLoading } = useFileDownload();

  const output = async (resumeData: ResumeDto) => {
    const url = await download(resumeData);
    if (!url) return;

    await fileSave(url);
  };
  return {
    loading: loading || fileSaveLoading,
    output,
  };
};
export default usePdfOutput;
